<template>
  <div class="landing-page-form">
    <div class="landing-page-form__landing-page">
      <div class="landing-page-form__landing-page__label">Landing Page</div>
      <div
        class="form-check form-check-inline"
        v-for="(option, optionIndex) in landing_type"
        :key="option.value + optionIndex + 'desc'"
      >
        <input
          type="radio"
          class="form-check-input"
          :id="option.value + optionIndex + 'desc'"
          :value="option.value"
          v-model="advert.landing_page_type"
        />
        <label
          :for="option.value + optionIndex + 'desc'"
          class="form-check-label"
          >{{ option.label }}</label
        >
      </div>
    </div>

    <CInput
      v-if="advert.landing_page_type === 'url'"
      v-model="advert.landing_url"
      label="Landing URL *"
      invalid-feedback="Please enter a valid URL (e.g., https://example.com)"
      :is-valid="urlValidator"
    />

    <CInput
      v-if="advert.landing_page_type === 'nw_post'"
      v-model="advert.landing_url"
      label="NW Post URL"
      :invalid-feedback="nwPostInvalidFeedback"
      :is-valid="nwPostUrlValidator"
    />

    <div v-if="advert.landing_page_type === 'lead'">
      <label for="leadForm">Lead Form</label>
      <multiselect
        id="leadForm"
        v-model="advert.lead_form"
        :multiple="false"
        track-by="id"
        label="form_name"
        :options="forms"
      >
        <span slot="noResult"
          >Oops! No Lead Form with the name. Consider changing the search
          query.</span
        >
      </multiselect>
      <br />
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import { LANGING_PAGE_TYPES } from '../../../constant/constants';

export default {
  name: 'LandingPageForm',
  components: { Multiselect },
  props: {
    advertisement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      landing_type: LANGING_PAGE_TYPES,
    };
  },
  computed: {
    advert() {
      return this.advertisement;
    },
    forms() {
      let forms = [];
      this.$store.getters.getLeadForms.forEach((item) => {
        let dd = { id: item.id, form_name: item.form_name };
        forms.push(dd);
      });
      forms.sort((a, b) => a.form_name.localeCompare(b.form_name));
      return forms;
    },
    nwPostInvalidFeedback() {
      return process.env.VUE_APP_APP_ENV !== 'production'
        ? 'NW post URL must start with https://dev-website.newswav.dev'
        : 'NW post URL must start with https://newswav.com';
    },
  },
  methods: {
    nwPostUrlValidator(val) {
      // eslint-disable-next-line no-useless-escape
      let regex = /^https\:\/\/(dev\.)?newswav.com/i;
      if (process.env.VUE_APP_APP_ENV !== 'production') {
        // eslint-disable-next-line no-useless-escape
        regex = /^https:\/\/dev-website\.newswav.dev/i;
      }
      return regex.test(val);
    },
    urlValidator(val) {
      if (!val) return false;

      try {
        const url = new URL(val);
        return url.protocol === 'http:' || url.protocol === 'https:';
      } catch (error) {
        return false;
      }
    },
    validator(val) {
      return val ? val !== '' : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-page-form__landing-page {
  margin-top: 15px;
  margin-bottom: 15px;
  &__label {
    margin-bottom: 8px;
  }
}
</style>
